import { useReveal } from "../lib/useReveal";

const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1699185190937-5d9571a1425f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBueWMlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzc4MzA2MjMzfDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const r1 = useReveal();
  const r2 = useReveal();
  const r3 = useReveal();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      {/* Ambient glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 right-0 h-[28rem] w-[28rem] rounded-full bg-white/[0.04] blur-3xl float-slower"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: eyebrow + heading */}
          <div className="lg:col-span-5">
            <div ref={r1} className="reveal">
              <span className="text-xs uppercase tracking-[0.28em] text-neutral-500 font-medium">
                01 / About
              </span>
              <h2
                data-testid="about-heading"
                className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter leading-[1.02]"
              >
                The agency
                <br />
                for the
                <br />
                <span className="italic font-medium">internet era.</span>
              </h2>
            </div>

            <div
              ref={r3}
              className="reveal mt-10 hidden lg:block overflow-hidden rounded-2xl border border-white/10"
              style={{ transitionDelay: "200ms" }}
            >
              <img
                src={ABOUT_IMAGE}
                alt="Modern architecture"
                className="w-full h-[360px] object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>

          {/* Right: copy + signal list */}
          <div className="lg:col-span-7 lg:pl-8">
            <div ref={r2} className="reveal">
              <p
                data-testid="about-paragraph"
                className="text-xl md:text-2xl text-neutral-200 leading-relaxed font-body font-light"
              >
                OuttaRage Management helps creators grow audiences, secure brand deals,
                negotiate partnerships, and organize campaigns — building long-term
                brands across social media and internet culture.
              </p>
              <p className="mt-6 text-base md:text-lg text-neutral-400 leading-relaxed">
                We sit at the intersection of music, media, and creator economy. Our
                creators don&apos;t chase trends; they make them. We handle the business so
                they can focus on the work.
              </p>

              <ul className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6">
                {[
                  "End-to-end deal management",
                  "Brand-side & creator-side strategy",
                  "Partnership outreach at scale",
                  "Campaign rollout & reporting",
                  "Long-term brand building",
                  "Music & internet culture native",
                ].map((item, i) => (
                  <li
                    key={item}
                    data-testid={`about-bullet-${i}`}
                    className="flex items-start gap-4 group"
                  >
                    <span className="mt-2 inline-block h-px w-6 bg-white/30 group-hover:bg-white transition-colors" />
                    <span className="text-sm md:text-base text-neutral-300">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
